@if (templateRef) {
<ng-container [ngTemplateOutlet]="templateRef" />
} @else {
<span [innerHTML]="message"></span>
}
